module.exports = __webpack_public_path__ + "static/media/website.028ba9ab.svg";